import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-55bce240"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "trade-header"
};
const _hoisted_2 = {
  class: "arrow"
};
const _hoisted_3 = {
  class: "last"
};
const _hoisted_4 = {
  style: {
    "font-size": "14px"
  }
};
const _hoisted_5 = {
  class: "info-item"
};
const _hoisted_6 = {
  class: "label"
};
const _hoisted_7 = {
  class: "info-item"
};
const _hoisted_8 = {
  class: "label"
};
const _hoisted_9 = {
  class: "value"
};
const _hoisted_10 = {
  class: "info-item"
};
const _hoisted_11 = {
  class: "label"
};
const _hoisted_12 = {
  class: "value"
};
const _hoisted_13 = {
  key: 0,
  class: "info-item"
};
const _hoisted_14 = {
  class: "label"
};
const _hoisted_15 = {
  class: "value"
};
const _hoisted_16 = {
  class: "value"
};
const _hoisted_17 = {
  class: "value"
};
const _hoisted_18 = {
  style: {
    "flex": "1",
    "display": "flex",
    "justify-content": "end"
  }
};
const _hoisted_19 = {
  class: "arrow"
};
const _hoisted_20 = {
  class: "arrow"
};
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons-vue';
export default {
  __name: 'TradeHeader',
  props: {
    name: {
      type: String,
      default: '--'
    },
    last: {
      tyle: String,
      default: '0'
    },
    high: {
      type: String,
      default: '0'
    },
    low: {
      type: String,
      default: '0'
    },
    vol: {
      type: String,
      default: '0'
    },
    up: {
      type: Boolean,
      default: false
    },
    growth: {
      type: String,
      default: '0.00'
    },
    arrow: {
      type: Boolean,
      default: false
    },
    arrow1: {
      type: Boolean,
      default: false
    },
    arrow2: {
      type: Boolean,
      default: false
    },
    indices: {
      type: Boolean,
      default: false
    }
  },
  emits: ['changeArrow', 'changeArrow1', 'changeArrow2'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const introModal = ref(false);
    const toLink = () => {
      window.open('https:///kbfwhitepaper.one');
    };
    return (_ctx, _cache) => {
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "name",
        onClick: _cache[0] || (_cache[0] = $event => emit('changeArrow', !props.arrow))
      }, [_createTextVNode(_toDisplayString(props.name), 1), props.indices == false ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode("/USDT")], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [props.arrow ? (_openBlock(), _createBlock(_unref(CaretUpOutlined), {
        key: 0
      })) : (_openBlock(), _createBlock(_unref(CaretDownOutlined), {
        key: 1
      }))])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "last-num",
        style: _normalizeStyle({
          color: props.up ? '#04AC92' : '#EC2752'
        })
      }, _toDisplayString(props.last), 5), _createElementVNode("span", _hoisted_4, "$" + _toDisplayString(props.last), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('trend')), 1), _createElementVNode("div", {
        class: "value",
        style: _normalizeStyle({
          color: props.up ? '#04AC92' : '#EC2752'
        })
      }, _toDisplayString(props.growth) + "%", 5)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('high24H')), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(props.high), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('low24H')), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(props.low), 1)]), props.indices == false ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('num24H')), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(props.vol), 1)])) : _createCommentVNode("", true), props.name == 'KBF' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "info-item",
        style: {
          "cursor": "pointer"
        },
        onClick: _cache[1] || (_cache[1] = $event => introModal.value = true)
      }, [_createElementVNode("div", _hoisted_16, [_createTextVNode(_toDisplayString(_unref(t)('tokenIntroduction')), 1), _createVNode(_unref(CaretDownOutlined))])])) : _createCommentVNode("", true), props.name == 'KBF' ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "info-item",
        style: {
          "cursor": "pointer"
        },
        onClick: toLink
      }, [_createElementVNode("div", _hoisted_17, [_createTextVNode(_toDisplayString(_unref(t)('newWhitepaper')), 1), _createVNode(_unref(CaretDownOutlined))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
        class: "info-item",
        style: {
          "display": "flex",
          "align-items": "center",
          "cursor": "pointer",
          "font-weight": "700"
        },
        onClick: _cache[2] || (_cache[2] = $event => emit('changeArrow1', !props.arrow1))
      }, [_createElementVNode("span", null, _toDisplayString(_unref(t)('position')), 1), _createElementVNode("div", _hoisted_19, [props.arrow1 ? (_openBlock(), _createBlock(_unref(CaretUpOutlined), {
        key: 0
      })) : (_openBlock(), _createBlock(_unref(CaretDownOutlined), {
        key: 1
      }))])]), _createElementVNode("div", {
        class: "info-item",
        style: {
          "display": "flex",
          "align-items": "center",
          "cursor": "pointer",
          "font-weight": "700"
        },
        onClick: _cache[3] || (_cache[3] = $event => emit('changeArrow2', !props.arrow2))
      }, [_createElementVNode("span", null, _toDisplayString(_unref(t)('newTrade')), 1), _createElementVNode("div", _hoisted_20, [props.arrow2 ? (_openBlock(), _createBlock(_unref(CaretUpOutlined), {
        key: 0
      })) : (_openBlock(), _createBlock(_unref(CaretDownOutlined), {
        key: 1
      }))])])])]), _createVNode(_component_a_modal, {
        visible: introModal.value,
        "onUpdate:visible": _cache[4] || (_cache[4] = $event => introModal.value = $event),
        footer: null,
        width: "500px",
        centered: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_unref(t)('kbfIntro1')), 1), _createElementVNode("div", null, _toDisplayString(_unref(t)('kbfIntro2')), 1), _createElementVNode("div", null, _toDisplayString(_unref(t)('kbfIntro3')), 1)]),
        _: 1
      }, 8, ["visible"])], 64);
    };
  }
};